
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { formRules } from "@/utils/formRules";
import SimpleDialog from "@/components/SimpleDialog.vue";
import MylobyAutocomplete from "@/components/generic/autocomplete.vue";
import RelaysAutocomplete from "@/components/relays/RelaysAutocomplete.vue";


@Component({
  components: { SimpleDialog, MylobyAutocomplete, RelaysAutocomplete },
})
export default class RequestTransfer extends Vue {

    get canSubmit(): boolean {
        return this.valid && !!this.relayId;
    }

    @Getter private isMobile: boolean;
    @Getter private envCompanyId: number|null;

    private registrationNumber: string = "";
    private contactEmail: string = "";
    private showDialog: boolean = false;

    private valid: boolean = true;
    private loading: boolean = false;
    private rules = formRules;
    private relayId: number | null = null;

    private init(): void {
        this.registrationNumber = "";
        this.contactEmail = "";
        this.relayId = null;
        this.showDialog = false;
    }

  /**
   * Send a building transfer request to another company.
   *
   * @return {Promise<void>} Resolves if the building can be requested successfully, otherwise, it throws an error.
   */
  private async requestBuildingTransfer(): Promise<void> {
    this.loading = true;
    await this.$store.dispatch("buildingTransfers/requestTransfer", {
        registrationNumber: this.registrationNumber,
        contactEmail: this.contactEmail,
        relayId: this.relayId,
      })
        .then((data) => {
          this.$store.commit("alerts/displaySuccess", {
            msg: this.$i18n?.t("Buildings.transfer.requestSent"),
          });
          this.init();
        })
        .catch((error) => {
          this.$store.commit("alerts/displayHttpError", { error });
        })
        .finally(() => {
            this.loading = false;
         });
  }
}
